import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const PASSWORD_MIN_LENGTH = 12;

/**
 * Validates a new password against the application's required rules:
 *   - Minimum 12 characters
 *   - At least 1 letter
 *   - At least 1 number
 *
 * Upper/lowercase and special characters are encouraged but not enforced.
 * Use alongside Validators.required — this validator skips empty values.
 *
 * Errors returned:
 *   passwordTooShort  — fewer than 12 characters
 *   passwordNoLetter  — no letter found
 *   passwordNoNumber  — no number found
 */
export function passwordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value || '';

    // Let Validators.required handle empty values
    if (!value) return null;

    const errors: ValidationErrors = {};

    if (value.length < PASSWORD_MIN_LENGTH) {
      errors['passwordTooShort'] = { requiredLength: PASSWORD_MIN_LENGTH, actualLength: value.length };
    }

    if (!/[a-zA-Z]/.test(value)) {
      errors['passwordNoLetter'] = true;
    }

    if (!/[0-9]/.test(value)) {
      errors['passwordNoNumber'] = true;
    }

    return Object.keys(errors).length > 0 ? errors : null;
  };
}
